<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">自然キャピタルにどうピッチするべきか</h1>
                <span class="meta"> Posted in April 2024 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/shizen_pitch_bw.jpg" alt="">
                </figure>

<p>自然キャピタルのゼネラル・パートナー、またベンチャー・キャピタリストとして働けることを大変嬉しく思っています。私たちは、ベンチャーキャピタルになる前に、テック系スタートアップを立ち上げた経験もあります。私たちは優秀だったというより、幸運に恵まれていいたという方が正しいです。私たちがしばしば思いつく知恵や閃きは、私たちが起業家時代、またVC初期の世間知らずの投資家として犯した目も眩むような大量の失敗を通じた学びから生まれるものです。また目利き力は、多くのスタートアップと向き合うというのが日々の仕事ゆえに、幾度となく、成長するテック企業を実際に目の当たりにしてきたからです。</p>
<p>「どのように私たちにピッチすべきか」については、教科書のようなHow toではなく、むしろ以下の2つの具体的な目的を追求するための現実的なアドバイスを提供するためです:)</p>
<p>i）Fundの管理者として責任を持ってFundのゴールに向け運営すること、ii）ファウンダーたちの時間の使い方を最適化/節約すること。時間が大きな資産であるファウンダーにとってもベネフィットであり成功の可能性を高めることだと信じています。</p>
<p>私たちは毎年、何百件もの投資案件の相談を受けますが、そのすべてにお答えすることはできません。ここでは、私たちの関心を引き、説得力のある投資提案をするための実践的な方法をいくつかご紹介します。</p>

                <h2 class="subheading">アプローチ:</h2>
<p>最初のアプローチのゴールは、投資の説得ではなく、むしろあなたとミーティングや電話会議を設定したいと私たちが思えるかどうかです。</p>
<ul>お墨付きの紹介者（例えば、当社の投資先企業やネットワーク内の信頼できる人物など）を介して当社にコンタクトすることで、弊社の注目度も変わります。</ul>
<ul>とは言え、私たちはアクセスしやすいというFundという自負もありますので、独創的な方法で直接コンタクトを取ることも注目度が上がります。弊社のMarkは最近、自身のブログ記事によく前向きなコメントをしている起業家から投資相談のアプローチを受けた時、躊躇無く彼とのミーティングを設定しました。</ul>
<ul>私たちの投資スイートスポットの説明を読むことで、私たちとのミーティングの妥当性を事前に確認することができます。スイートスポットに明らかに該当していない場合は、あなたの会社がどのようにフィットするのか説明が必要です。また、Markのブログを読んだり、投資先企業を分析することで、当社の投資哲学を理解することができます。</ul>
<ul>また、私たちにご連絡頂く前に、そもそもあなたのスタートアップがVCからの資金調達が適切なのかぜひ熟考してみてください。このトピックに関連するVCの数学に関する記事をお読みになることをお勧めします。</ul>
<ul>事前のNDA締結はしておりません。（より詳細な理由・根拠をご一読ください）。私たちの信頼できるアドバイザーに共有し意見を求めても大丈夫な機密性のないピッチデックをお送りください。</ul>
<ul>明確で簡潔な要旨を送ることを心がけてください。（形式にはこだわりませんが、私たちは外出先でメールを読むことも多いので、クラウドリンクへのアクセスやステップが必要なものは、見送ってしまうこともあります。）</ul>
<ul>複数の受信者への大量のメール、コールバックを要求するcold mail,また当社の投資範囲や理念を全く確認していないことが明らかなメールなどは、言うまでもなく対象にはなりません。</ul>

                <h2 class="subheading">最初のミーティング：</h2>
<ul>1時間以内に効率的な話し合いができるよう準備してください。むしろ50分程度であればなお良く、その後のミーティングにも問題なく臨むことができます。</ul>
<ul>課題の特定、またその課題に対する解決策のビジョンを明確に説明してください。</ul>
<ul>私たちに何を求めているのかを具体的に伝えてください。</ul>
<ul>私たちは、あなたのExit戦略（例えば「7年後に東証グロースでIPOする予定です」）よりも、あなたの野心に興味をそそられます。不確実なExit戦略への安易な見方は、むしろの見方の甘さを露呈することにもなります。</ul>

                <h2 class="subheading">私たちのコミットメント:</h2>
<ul>私たちはミーティングの際、全身全霊であなたに集中します。つまり、ミーティング中にスマートフォンでメールするなど、気を散らすことがないということです。</ul>
<ul>私たちはミーティング中に、私たちの業績をわざわざ説明することに時間を無駄にすることはありません。実際、私たちは自然キャピタルについてできるだけ簡潔にお伝えし、関連する範囲でのみ話すようにしています。（もちろん、その点をあなたが聞きたい場合は自由にご質問ください。重要なのは、その1時間はあなたのものであり、あなたが最も重要とすることに集中するためにある、ということです）。</ul>
<ul>美味しいコーヒーか紅茶をお出しします。もし私たちが会話に夢中になりその点を忘れるようなことがありましたら、ぜひ遠慮なく仰ってください！</ul>
<ul>私たちは、ミーティング後に投資意図について率直に述べます。もし現時点で投資するつもりがないのであれば、できるだけ早い段階でそれを明らかにし、次に進んでいただけるようにします。終わりのないデューデリジェンスの試練であなたを苦しめることはありません。私たちは迅速に投資先を決定し、迅速に行動することができます。しかし時には、私たちが関心を抱いていても、あなたのスタートアップへの投資を優先させるだけの十分な投資枠がないこともあります。その場合はその旨をお伝えします。</ul>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
